module.exports = __webpack_public_path__ + "static/media/adam_cutrone.d74432b3.jpg";